import Component from '../../common/Component';
import ItemList from '../../common/utils/ItemList';
export default class Footer extends Component {
  view() {
    const items = this.items().toArray();

    // Nothing has been added, so nothing is rendered -- an empty container
    // would still take up its own padding at the bottom of every page.
    if (!items.length) return null;
    return m("div", {
      className: "Footer-container container"
    }, items);
  }
  items() {
    return new ItemList();
  }
}
flarum.reg.add('core', 'forum/components/Footer', Footer);